// Slices
import {
  CountryCode,
  countryCodes,
  getCountryCodeFromRoles,
  ICountrySelect,
  selectForCountries,
} from '@domains/country';

// store.
import { apiAuth, apiAuthV2 } from '.';

export interface IResponseAuthTransformed {
  countriesByUser: CountryCode[];
  countriesSelect: ICountrySelect[];
  roles: string[];
}

export interface AuthResponse {
  role: string[];
  success: boolean;
}

export const auth = apiAuth.injectEndpoints({
  endpoints: builder => ({
    auth: builder.mutation({
      query: ({ userId }: { userId: string }) => ({
        body: { userId },
        method: 'POST',
        url: '/get_cognito_user_role',
      }),
      transformResponse: (response: AuthResponse): IResponseAuthTransformed => {
        const countriesByUser = getCountryCodeFromRoles(response.role);
        const countriesSelect = selectForCountries(countriesByUser);
        const roles = response.role.filter(
          role => !countryCodes.includes(role as CountryCode)
        );

        return { countriesByUser, countriesSelect, roles };
      },
    }),
  }),
});

export const authV2 = apiAuthV2.injectEndpoints({
  endpoints: builder => ({
    getUserRole: builder.query<
      IResponseAuthTransformed,
      {
        country: CountryCode | string;
        userId: string;
        external: boolean;
      }
    >({
      query: ({ country, userId, external }) => ({
        url: `/get_cognito_user_role?country=${country}&userId=${userId}&external=${external}`,
        method: 'GET',
      }),
      transformResponse: (response: AuthResponse): IResponseAuthTransformed => {
        const countriesByUser = getCountryCodeFromRoles(response.role);
        const countriesSelect = selectForCountries(countriesByUser);
        const roles = response.role.filter(
          role => !countryCodes.includes(role as CountryCode)
        );

        return { countriesByUser, countriesSelect, roles };
      },
    }),
  }),
});

export const { useAuthMutation } = auth;
export const { useGetUserRoleQuery, useLazyGetUserRoleQuery } = authV2;
